<mat-toolbar class="fx-row fx-r-center-center" color="primary">
  <img
    class="logo"
    src="{{ getPartnerLogo() }}"
    (error)="handleImgError($event)"
    (load)="handleImgLoad($event)"
  />
</mat-toolbar>
